import { buildWaMeUrl } from '../../utils/whatsappSupport';

export default function TrainingPendingBanner({ user, onOpenAccount }) {
  const whatsapp = user?.coach_branding?.support_whatsapp
    || user?.trainer?.support_whatsapp
    || user?.support_whatsapp
    || '';
  const waUrl = whatsapp ? buildWaMeUrl(whatsapp, 'Hola, acabo de registrarme en Training y mi cuenta está pendiente de activación.') : null;

  return (
    <div
      className="rounded-xl border border-amber-400/40 bg-amber-500/10 p-4 sm:p-6 space-y-4"
      role="alert"
    >
      <h2 className="font-bold text-[var(--d28d-text)] text-base uppercase tracking-wide">
        Cuenta pendiente de activación
      </h2>
      <p className="text-sm text-[var(--d28d-text)] opacity-90">
        Tu cuenta fue creada correctamente. Estamos validando tu acceso con el administrador central
        o tu entrenador (según el método de pago elegido).
      </p>
      <p className="text-xs d28d-text-muted">
        Mientras tanto puedes revisar Mi Cuenta. Cuando se confirme el pago o la activación,
        se habilitará tu rutina, progreso y demás funciones Training.
      </p>
      <div className="flex flex-wrap gap-2">
        {waUrl ? (
          <a href={waUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary text-sm">
            Contactar entrenador (WhatsApp)
          </a>
        ) : null}
        {onOpenAccount ? (
          <button type="button" className="btn btn-secondary text-sm" onClick={onOpenAccount}>
            Mi Cuenta
          </button>
        ) : null}
      </div>
    </div>
  );
}
